import { render, staticRenderFns } from "./AlertSuccess.vue?vue&type=template&id=46a35054&scoped=true&"
import script from "./AlertSuccess.vue?vue&type=script&lang=js&"
export * from "./AlertSuccess.vue?vue&type=script&lang=js&"
import style0 from "./AlertSuccess.vue?vue&type=style&index=0&id=46a35054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a35054",
  null
  
)

export default component.exports